<template>
  <div class="login">
    <div class="title">货主登录</div>
    <div class="cont">
      <van-form @submit="onSubmit">
        <div class="form-box">
          <van-field
            v-model="username"
            name="username"
            placeholder="请输入用户名"
            clearable
            :rules="[{ required: true, message: '请填写用户名' }]"
          ></van-field>
          <van-field
            v-model="password"
            name="password"
            type="password"
            clearable
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          ></van-field>
        </div>
        <div class="form-btn">
          <van-button block type="info" :disabled="disabled" native-type="submit">
            登录
          </van-button>
        </div>
      </van-form>
      <div class="cont-tips">
        <span @click="toPage('/Forget')">忘记密码</span> |
        <span @click="toPage('/Register')">注册账号</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      username:'费旭伟货主',
      password:'123456',
      disabled:false
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onSubmit(values) {
      console.log('submit', values);
      let data = {...values};
      this.$api.apis.loginSupply(data).then(res => {
        console.log(res)
        if(res.code == '200'){
          this.$toast('登录成功')
          localStorage.setItem("token", res.data);
          this.$router.replace('/Invoice')
        }else{
          this.$toast(res.mass)
          this.disabled = false;
        }
      }).catch((e) => {
        console.log(e)
      })
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/login.less';
</style>



// WEBPACK FOOTER //
// src/pages/Login/index.vue